import React from "react";

import { wrap } from "./RydTestbedWrap";
import RydMiniWindow from "../components/widgets/RydMiniWindow";

export function MiniWindowTestbed() {
    return wrap(<>
        {/* Add your testbed components here */}
        <h1>MiniWindow Testbed</h1>
        <RydMiniWindow>
            <div style={{ padding: "20px" }}>
                <h2>Drag Me!</h2>
                <p>This is a mini window that you can drag around.</p>
            </div>
        </RydMiniWindow>
    </>);
}